import { render, staticRenderFns } from "./ModalMember.vue?vue&type=template&id=6ab15f3a&scoped=true&"
import script from "./ModalMember.vue?vue&type=script&lang=js&"
export * from "./ModalMember.vue?vue&type=script&lang=js&"
import style0 from "./ModalMember.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab15f3a",
  null
  
)

export default component.exports